import { render, staticRenderFns } from "./cost_setting.vue?vue&type=template&id=75940921&"
import script from "./cost_setting.vue?vue&type=script&lang=js&"
export * from "./cost_setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports